import React, { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import SocialWidget from '../Widget/SocialWidget';
import Newsletter from '../Widget/Newsletter';
import './header.scss';
import ContactInfoWidget from '../Widget/ContactInfoWidget';
import Div from '../Div';
import DropDown from './DropDown';
import { isUserLoggedIn, clearAuthData, getUser } from '../../utils/authStorage';

export default function Header({ variant }) {
  const [isSticky, setIsSticky] = useState(false);
  const [sideHeaderToggle, setSideHeaderToggle] = useState(false);
  const [mobileToggle, setMobileToggle] = useState(false);
  useEffect(() => {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 0) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    });
  }, []);

  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    setIsLoggedIn(isUserLoggedIn());
  }, []);

  const handleLogout = () => {
    clearAuthData();
    setIsLoggedIn(false);
    window.location.href = '/'; // or use navigate('/') if using react-router-dom v6
  };

  return (
    <>
      <header
        className={`cs-site_header cs-style1 text-uppercase ${
          variant ? variant : ''
        } cs-sticky_header ${isSticky ? 'cs-sticky_header_active' : ''}`}
      >
        <Div className="cs-main_header">
          <Div className="container">
            <Div className="cs-main_header_in">
              <Div className="cs-main_header_left">
                <Link className="cs-site_branding" to="/">
                  <img src="/images/logo-lixr.png" alt="Logo" />
                </Link>
              </Div>
              <Div className="cs-main_header_center">
                <Div className="cs-nav cs-primary_font cs-medium">
                  <ul
                    className="cs-nav_list"
                    style={{ display: `${mobileToggle ? 'block' : 'none'}` }}
                  >
                    <li >
                      <NavLink to="/" onClick={() => setMobileToggle(false)}>
                        Home
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/about"
                        onClick={() => setMobileToggle(false)}
                      >
                        About
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/service"
                        onClick={() => setMobileToggle(false)}
                      >
                        Services
                      </NavLink>
                    </li>
                    
                    <li>
                      <NavLink
                        to="/project"
                        onClick={() => setMobileToggle(false)}
                      >
                        Projects
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/all-products"
                        onClick={() => setMobileToggle(false)}
                      >
                        Products
                      </NavLink>
                    </li>
                    <li className="menu-item-has-children">
                      <Link to="#" onClick={() => setMobileToggle(false)}>
                        Others
                      </Link>
                      <DropDown>
                        <ul>
                          <li>
                            <Link to="/contact" onClick={() => setMobileToggle(false)}>
                              Contact
                            </Link>
                          </li>
                          <li>
                            <Link to="/alljobs" onClick={() => setMobileToggle(false)}>
                              Vacancies
                            </Link>
                          </li>

                          {isLoggedIn && (
                            <>
                              <li>
                                <Link to="/order-details" onClick={() => setMobileToggle(false)}>
                                  Order Details
                                </Link>
                              </li>
                              <li>
                                <Link to="/profile" onClick={() => setMobileToggle(false)}>
                                  Profile
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to="#"
                                  onClick={(e) => {
                                    e.preventDefault(); // prevent actual navigation
                                    setMobileToggle(false); // close the menu
                                    handleLogout(); // perform logout
                                  }}
                                >
                                  Logout
                                </Link>
                              </li>
                            </>
                          )}

                          {!isLoggedIn && (
                            <li>
                              <Link to="/login" onClick={() => setMobileToggle(false)}>
                                Login
                              </Link>
                            </li>
                            
                          )}
                          {!isLoggedIn && (
                            <li>
                              <Link to="/register" onClick={() => setMobileToggle(false)}>
                                Register
                              </Link>
                            </li>
                            
                          )}
                        </ul>
                      </DropDown>
                    </li>
                  </ul>
                  <span
                    className={
                      mobileToggle
                        ? 'cs-munu_toggle cs-toggle_active'
                        : 'cs-munu_toggle'
                    }
                    onClick={() => setMobileToggle(!mobileToggle)}
                  >
                    <span></span>
                  </span>
                </Div>
              </Div>
              <Div className="cs-main_header_right">
                <Div className="cs-toolbox">
                  <span
                    className="cs-icon_btn"
                    onClick={() => setSideHeaderToggle(!sideHeaderToggle)}
                  >
                    <span className="cs-icon_btn_in">
                      <span />
                      <span />
                      <span />
                      <span />
                    </span>
                  </span>
                </Div>
              </Div>
            </Div>
          </Div>
        </Div>
      </header>

      <Div
        className={
          sideHeaderToggle ? 'cs-side_header active' : 'cs-side_header'
        }
      >
        <button
          className="cs-close"
          onClick={() => setSideHeaderToggle(!sideHeaderToggle)}
        />
        <Div
          className="cs-side_header_overlay"
          onClick={() => setSideHeaderToggle(!sideHeaderToggle)}
        />
        <Div className="cs-side_header_in">
          <Div className="cs-side_header_shape" />
          <Link className="cs-site_branding" to="/">
            <img src="/images/logo-lixr.png" alt="Logo" />
          </Link>
          <Div className="cs-side_header_box">
            <h2 className="cs-side_header_heading">
              Together, We Can Build Something <br/> Great
            </h2>
          </Div>
          <Div className="cs-side_header_box">
            <ContactInfoWidget title="Contact Us" withIcon />
          </Div>
          <Div className="cs-side_header_box">
            <Newsletter
              title="Subscribe"
              subtitle=""
              placeholder="lixrinnovation@gmail.com"
            />
          </Div>
          <Div className="cs-side_header_box">
            <SocialWidget />
          </Div>
        </Div>
      </Div>
    </>
  );
}
